import React from "react";
import styled from "styled-components";

import lo from "../assets/1.png";
import lo2 from "../assets/2.png";
import lo3 from "../assets/3.png";
import lo4 from "../assets/4.png";
import lo5 from "../assets/5.png";
import lo6 from "../assets/6.png";


const services = [

{
img:lo3,
title:"עובדי ניקיון וצוותי ניקיון",
text:"   לפתוח את הבוקר במשרד נקי, רענן ומזמין. חברתנו מספקת צוותי ניקיון מקצועיים בסטנדרט הגבוה ביותר ובמחירים המשתלמים בשוק, כדי שתוכלו להתרכז במה שחשוב באמת – העסק שלכם. זמינות : צוותי הניקיון זמינים לפי הצרכים שלכם. מקצועיות ללא פשרות : עובדים מנוסים, מיומנים ומפוקחים המקפידים על כל פרט. התאמה אישית מלאה: תוכנית ניקיון ייעודית המותאמת לגודל המשרד ואופי הפעילות בו. המשתלם ביותר לעסק : שירות פרימיום בתוצאות, במחירים תחרותיים ואטרקטיביים. "
},


{
img:lo2,
title:"קרצוף פוליש לרצפה ופוליש ווקס",
text:"מחזירים לרצפה את הברק והמראה המקורי שלה. חברתנו מתמחה בטיפולי פוליש מתקדמים ברמה הגבוהה ביותר, שיגרמו למשטח שלכם להיראות חדש לחלוטין – ובמחירים האטרקטיביים בשוק. תוצאות ש: קרצוף עמוק המעלים כתמים, שריטות ולכלוך קשה שלא יורד בשטיפה רגילה. הגנה מקסימלית לרצפה: שכבת פוליש ווקס איכותית השומרת על המשטח ומעניקה לו מראה מבריק לאורך זמן. טכנולוגיה ומכשור חדיש: שימוש במכונות פוליש ייעודיות ובחומרים המובילים בתעשייה. החברה המובילה בתחום: שירות מקצועי, מהיר וקפדני באחריות מלאה ובמחיר המשתלם ביותר."
},


{
img:lo,
title:"ניקיון ואחזקות נכסים מסחריים",
text:"  חברתנו מספקת מענה מקיף, מקצועי ומתקדם לכל צורכי הניקיון והתחזוקה במגזר העסקי והמסחרי. אנו מתחייבים לסטנדרט שירות ללא פשרות, תוך התאמה מלאה ללוחות הזמנים של העסק שלכם. השירותים המובילים שלנו : ניקיון משרדים ובנייני מסחר – תחזוקה שוטפת באווירה רעננה ונקייה. ניקיון לאחר שיפוץ – הכנת הנכס מאפס ועד למסירה מושלמת. ניקיון לפני אכלוס – כניסה חלקה, נקייה והיגיינית לנכס החדש שלכם. למה לבחור בנו? טכנולוגיה וחומרים – שימוש במכשור מכאני מתקדם ובחומרי הניקוי המובילים והבטוחים בשוק. תמחור הוגן ושקוף – פתרונות ניקיון מתקדמים במחירים אטרקטיביים ותחרותיים. שקט נפשי מלא – אנו מעניקים אחריות מלאה על איכות וביצוע של כל עבודה בשטח. "
},


{
img:lo6,
title:"שירותי הנדימן לנכסים מסחריים",
text:"  מענה מקיף לכל תיקון ותחזוקה במבני מסחר, משרדים ועסקים. אנו מטפלים בתיקונים קטנים כגדולים במקצועיות ללא פשרות, תוך דגש על שירות יעיל שאינו מפריע לשגרת העבודה שלכם.המומחיות שלנו בשטח כוללת: תיקוני צבע וגבס – תיקון חורים, סדקים, חידוש קירות משרד וצביעה אסתטית. התקנות ותלייה – תליית מסכים, לוחות מחיקים, גופי תאורה, מדפים ואלמנטים דקורטיביים. תחזוקת ריהוט ודלתות – תיקון והרכבת ריהוט משרדי, כיוון צירים, ידיעות ומנעולים. פתרונות אינסטלציה קלים – החלפת ברזים, פתיחת סתימות קלות וטיפול בנזילות מקומיות. למה לעבוד איתנו? ידי זהב לכל משימה : יכולת מוכחת לחדש, לתקן ולפתור כמעט כל בעיה בנכס. יחס אישי ומנהל זמין: ליווי ישיר של מנהל העסק לאורך כל הדרך. עמידה קפדנית בלוחות זמנים: הגעה בזמן ועבודה מהירה, מדויקת ונקייה. מחירים אטרקטיביים: תמחור הוגן ושקוף המותאם לצרכים של המגזר העסקי.  "
},


{
img:lo5,
title:"ניקיון שטחים פתוחים וציבוריים",
text:" חברתנו מספקת שירותי חצרנות על ידי חצרנים מקצועיים אשר מתמחים בניקיון שטחים פתוחים ובשימוש של מכונות ייעודיות לכל שטח בהתאמה, ציוד מכאני מתקדם : שימוש במטאטאים מכאניים, מפוחים ומכונות שטיפה בלחץ, התאמה מלאה לתנאי השטח : ניקוי יעיל של מדרכות, חניונים, פארקים ורחבות ציבוריות.צוות מיומן ומפוקח: חצרנים מקצועיים המקפידים על לוחות זמנים, בטיחות וסטנדרט גבוה.פתרונות בהתאמה אישית : שירות חד-פעמי לאירועים או תחזוקה שוטפת על בסיס קבוע."
},


{
img:lo4,
title:"  שירותי אחזקה שוטפת לנכסי מסחר ומבני ציבור ",
text:"חברתנו מספקת מעטפת אחזקה מקיפה ותחזוקה מונעת המותאמת באופן ייחודי לצרכים של כל בניין ונכס. אנו מעמידים לרשותכם שירותי אב בית מקצועיים ומנהלים את כלל מערכות המבנה תחת קורת גג אחת, כדי להבטיח לכם שקט תעשייתי מלא ותפעול רציף. השירותים המקצועיים שלנו כוללים : שירותי אב בית מותאמים : מענה גמיש לפי צורכי הלקוח – החל מהחלפת נורות ותיקונים קטנים, ועד לטיפול וניתוח חשבונות מים גבוהים לאיתור נזילות. תחזוקת מערכות אנרגיה ומים: ניקוי וחיטוי מאגרי מים, ותחזוקה שוטפת של מערכות סולאריות ומשאבות. בטיחות ומערכות חירום: בדיקת ספרינקלרים, תחזוקת רכזות כיבוי אש, והפעלה חודשית כולל טיפול רבעוני לגנרטורים. תשתיות ואוורור : טיפול במערכות המבנה השונות, מעליות ומפוחים. מעטפת שירותים משלימה : שירותי ניקיון יסודיים למבנה ועבודות גינון וטיפוח סביבתי."
}

];



const Section = styled.section`
  width: 100%;
  padding: 100px 20px;
  background: radial-gradient(circle at top, #1b3555, #050b14);
  direction: rtl;
`;

const Title = styled.h1`
  color: #fff;
  text-align: center;
  font-size: clamp(2.2rem, 5vw, 4.2rem);
  font-weight: 900;
  margin-bottom: 70px;
  text-shadow: 0 0 20px rgba(0,170,255,.5);
`;

const Grid = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;

  display: flex;
  flex-direction: column;
  gap: 45px;
`;

const Card = styled.div`
  width: 100%;
  background: rgba(255,255,255,.07);
  backdrop-filter: blur(18px);

  border-radius: 30px;

  padding: 50px;

  border: 1px solid rgba(255,255,255,.15);

  box-shadow:
      0 15px 50px rgba(0,0,0,.35),
      0 0 35px rgba(0,170,255,.15);

  transition: .35s ease;

  text-align:center;

  overflow:hidden;

  &:hover{
      transform:translateY(-8px);
      box-shadow:
      0 20px 60px rgba(0,0,0,.45),
      0 0 40px rgba(0,170,255,.45);
  }

  img{
      display:block;
      margin:0 auto 35px;

      width:180px;
      height:180px;

      object-fit:contain;

      background:white;

      border-radius:50%;

      padding:18px;

      box-shadow:
      0 10px 35px rgba(0,170,255,.35);

      transition:.4s;
  }

  &:hover img{
      transform:scale(1.08) rotate(2deg);
  }

  h3{
      font-size:3rem;
      color:#fff;
      font-weight:900;
      margin-bottom:28px;
  }

  p{
      color:#ececec;
      font-size:1.3rem;
      line-height:2.1;
      max-width:950px;
      margin:auto;
  }

  @media(max-width:900px){

      padding:35px 25px;

      img{
          width:140px;
          height:140px;
      }

      h3{
          font-size:1.6rem;
      }

      p{
          font-size:1rem;
          line-height:1.9;
      }

  }

  @media(max-width:500px){

      padding:30px 20px;

      border-radius:22px;

      img{
          width:120px;
          height:120px;
      }

      h3{
          font-size:1.35rem;
      }

      p{
          font-size:.98rem;
      }

  }
`;



export default function Services({reference}){


return(

<Section ref={reference}>


<Title id="השירותים שלנו"  >

השירותים שלנו

</Title>



<Grid>


{

services.map((item,index)=>(


<Card key={index}>


<img

src={item.img}

alt={item.title}

/>



<h3>

{item.title}

</h3>



<p>

{item.text}

</p>



</Card>


))

}



</Grid>



</Section>

);


}